import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/home',
    name: 'hub',
    component: () => import('@/views/SummaryPage.vue'),
  },
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/LoginPage.vue'),
  },
  {
    path: '/RankingPage',
    name: 'RankingPage',
    component: () => import('@/views/RankingPage.vue'),
  },
  {
    path: '/RankingPage2',
    name: 'RankingPage2',
    component: () => import('@/views/RankingPage2.vue'),
  },
  {
    path: '/DailyRankingPage',
    name: 'DailyRankingPage',
    component: () => import('@/views/DailyRankingPage.vue'),
  },
  {
    path: '/DailyRankingClassic',
    name: 'DailyRankingClassic',
    component: () => import('@/views/DailyRankingClassic.vue'),
  },
  {
    path: '/chatStudio',
    name: 'chatStudio',
    component: () => import('@/views/chatStudio.vue'),
  },
 {
    path: '/autoReport',
    name: 'autoReport',
    component: () => import('@/views/autoReport.vue'),
  },
    {
    path: '/AutoReportGenerator',
    name: 'AutoReportGenerator',
    component: () => import('@/views/AutoReportGenerator.vue'),
  },
    {
    path: '/chatStatistical',
    name: 'chatStatistical',
    component: () => import('@/views/chatStatistical.vue'),
  },
    {
    path: '/NationalControlMap',
    name: 'NationalControlMap',
    component: () => import('@/views/NationalControlMap.vue'),
  },

    {
    path: '/TileMapView',
    name: 'TileMapView',
    component: () => import('@/views/TileMapView.vue'),
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
